import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule, IonModal } from '@ionic/angular';

@Component({
  selector: 'app-multiple-options-modal',
  templateUrl: './multiple-options-modal.component.html',
  styleUrls: ['./multiple-options-modal.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [IonicModule, CommonModule, FormsModule ,ReactiveFormsModule]
})
export class MultipleOptionsModalComponent  implements OnInit {
  @ViewChild('optionsModal', { static: true }) optionsModal!: IonModal;

  @Input() options: string[] = [];
  @Input() selected: any[] | any = [];
  @Input() multiple: boolean = true;
  @Input() isOpen: boolean = false;
  @Input() openTrigger = false;

  @Output() selectionChange = new EventEmitter<string | string[]>();
  @Output() close = new EventEmitter<void>();

  filteredOptions: string[] = [];
  searchTerm: any;

  selectedValues: string[] = [];

  constructor() { }

  ngOnInit() {
    this.filteredOptions = [...this.options];
    // this.selectedValues = [...this.selected];
    if (Array.isArray(this.selected)) {
      this.selectedValues = [...this.selected];
    } else if (this.selected) {
      this.selectedValues = [this.selected];
    } else {
      this.selectedValues = [];
    }
  }


  filterOptions() {
    const term = this.searchTerm.toLowerCase();
    this.filteredOptions = this.options.filter(o => o.toLowerCase().includes(term));
  }

  onConfirm() {
    this.selectionChange.emit(this.selectedValues);
    this.close.emit();
    this.optionsModal.dismiss();
  }

  onCancel() {
    this.close.emit();
    this.selectedValues = [];
    this.optionsModal.dismiss();
  }

  onSearchChange(event: any) {
    const value = event.target.value?.toLowerCase() || '';
    this.filteredOptions = this.options.filter(opt =>
      opt.toLowerCase().includes(value)
    );
  }

  open() {
    this.filteredOptions = this.options || [];
    setTimeout(() => {
      this.optionsModal.present();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['openTrigger'] && this.openTrigger) {
      this.presentModal();
    }
  }

  async presentModal() {
    this.filteredOptions = [...this.options];

    if (Array.isArray(this.selected)) {
      if (this.selected.length === 1 && typeof this.selected[0] === 'string' && this.selected[0].includes(',')) {
        this.selectedValues = this.selected[0].split(',').map(opt => opt.trim());
      } else {
        this.selectedValues = [...this.selected];
      }
    } else {
      this.selectedValues = [];
    }

    await this.optionsModal.present();
  }


  isChecked(value: string): boolean {
    return this.selectedValues.includes(value);
  }

  checkboxChange(event: any): void {
    const value = event.detail.value;
    const checked = event.detail.checked;

    if (checked) {
      if (!this.selectedValues.includes(value)) {
        this.selectedValues.push(value);
      }
    } else {
      this.selectedValues = this.selectedValues.filter((v: any) => v !== value);
    }
  }

  onSingleSelect(event: any): void {
    const value = event.detail.value;
    this.selectedValues = [value];
  }

}
